import { render, staticRenderFns } from "@/agilis/components/Dashboard/DashboardTable/DashboardTable.html?vue&type=template&id=1f0e4c2a&scoped=true&external"
import script from "./TrackerDashboardTable.js?vue&type=script&lang=js&external"
export * from "./TrackerDashboardTable.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0e4c2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
